<footer class="text-center py-4 bg-black text-white-50">
  <small>&copy; {{ rights.year }} {{ rights.company_name }}. All Rights Reserved.</small>
</footer>
